import { createContext, useContext } from "react";

import type { UsageAnalyticsDateRange, UsageAnalyticsQueryApi } from "./types.ts";

export type UsageAnalyticsDataContext = Readonly<{
  api: UsageAnalyticsQueryApi;
  dataAnalysisEnabled: boolean;
  setDataAnalysisEnabled: (id: boolean) => void;
  dateRangeFilterEnabled: boolean;
  setDateRangeFilterEnabled: (id: boolean) => void;
  dateRange: UsageAnalyticsDateRange;
  setDateRange: (dateRange: UsageAnalyticsDateRange) => void;
  moduleVersionFilterEnabled: boolean;
  setModuleVersionFilterEnabled: (id: boolean) => void;
  moduleVersion?: string;
  setModuleVersion: (moduleVersion?: string) => void;
}>;

export const UsageAnalyticsDataContext = createContext<UsageAnalyticsDataContext | undefined>(undefined);
UsageAnalyticsDataContext.displayName = "UsageAnalyticsDataContext";

export const useUsageAnalyticsDataContext = () => {
  const thriveDataContext = useContext(UsageAnalyticsDataContext);
  if (!thriveDataContext) throw new Error(`No ${UsageAnalyticsDataContext.displayName} available.`);
  return thriveDataContext;
};
